import type { EntitlementKey } from "@/types";
import { BadgesUpForGrabs } from "./BadgesUpForGrabs";
import { GetPublished } from "./GetPublished";

/**
 * Paid-only dashboard extras. Rendered only when the Cohort's Product grants
 * them, so Dominion Free stays deliberately bare (KC-478: "no extras").
 */
export function DashboardExtras({ entitlements }: { entitlements: EntitlementKey[] }) {
  return (
    <>
      {entitlements.includes("publication") && <GetPublished />}
      {entitlements.includes("performance_badges") && <BadgesUpForGrabs />}
    </>
  );
}
